export default {
  getCartItems(state) {
    return state.cartItems
  },
}